import { $applyNodeReplacement } from "lexical";
import { ChannelDisplay } from "./channel-display";
import { ChannelNode } from "./channel-node";

import type { SerializedChannelNode } from "./channel-node";
import type {
  DOMConversionMap,
  DOMConversionOutput,
  DOMExportOutput,
  LexicalEditor,
  NodeKey,
} from "lexical";
import type { JSX } from "react";

export class ChannelNodeMui extends ChannelNode {
  static getType(): string {
    return super.getType();
  }

  constructor(channel_id: string, key?: NodeKey) {
    super(channel_id, key);
  }

  static clone(node: ChannelNodeMui): ChannelNodeMui {
    return new this(node.__channel_id, node.__key);
  }

  decorate(): JSX.Element {
    return <ChannelDisplay channel_id={this.__channel_id} />;
  }

  static importJSON(serializedNode: SerializedChannelNode): ChannelNodeMui {
    return new this(serializedNode.channel_id);
  }

  exportDOM(editor: LexicalEditor): DOMExportOutput {
    const superExportDom = super.exportDOM(editor);
    if (superExportDom.element instanceof HTMLElement) {
      superExportDom.element.setAttribute("data-lexical-channel-id", this.__channel_id);
    }
    return superExportDom;
  }
  static importDOM(): DOMConversionMap<HTMLSpanElement> | null {
    return {
      span: (element) => {
        if (element.nodeName !== "SPAN" || !element.hasAttribute("data-lexical-channel-id")) {
          return null;
        }
        return {
          conversion: (span): DOMConversionOutput => {
            const channel_id = span.getAttribute("data-lexical-channel-id");
            return {
              node: $createChatReferenceChannelNodeMui(channel_id!),
            };
          },
          priority: 0,
        };
      },
    };
  }
}

export function $createChatReferenceChannelNodeMui(channel_id: string): ChannelNode {
  const node = new ChannelNodeMui(channel_id);

  return $applyNodeReplacement(node);
}
